<h1 style="margin: 2em; text-align: center">
  Bienvenido al panel de administración de Novit
</h1>
<h1 style="margin: 2em; text-align: center">{{ user?.nombre }}</h1>
